import { useTranslation } from "react-i18next";

import { Label } from "@/components/_atoms/label";
import { Switch } from "@/components/_atoms/switch";

import { DatatableRowData } from "../datatable-types";
import { useDatatableContext } from "../use-datatable-context";

export function DatatableDisplayOptionsHeaderVisibilitySwitch<TData extends DatatableRowData>() {
  const { t } = useTranslation("common");
  const { state, setState } = useDatatableContext<TData>();
  const { showColumnHeaders } = state;

  const handleShowHeaderSwitch = (newCheckValue: boolean) => {
    setState({ state: { showColumnHeaders: newCheckValue } });
  };

  return (
    <div className="flex w-full flex-row items-center justify-between gap-2">
      <Label
        htmlFor="toggle-visibility-table-headers"
        className="mb-2 mr-4 w-44 text-xs font-medium text-muted-foreground"
      >
        {t("view.showColumnHeaders")}
      </Label>
      <Switch
        id="toggle-visibility-table-headers"
        checked={showColumnHeaders}
        onCheckedChange={handleShowHeaderSwitch}
        size="sm"
      />
    </div>
  );
}
